import { Box, Card, Chip, Dialog, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import ActorAvatar from "../ActorAvatar";
import DotMenu from "../DotMenu";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DownloadIcon from "@mui/icons-material/Download";
import { formatDateRange, formatDate } from "../../utils/dateTimeFormat";
import { TableAvatar } from "../../utils/dataGrid";
import BuildIcon from "@mui/icons-material/Build";
import PreviewIcon from "@mui/icons-material/Preview";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import Tooltip from "@mui/material/Tooltip";
import Translate from "../../utils/Translate";
import ConstructionIcon from "@mui/icons-material/Construction";
import Button from "@mui/material/Button";
import { RemoveRedEye, StickyNote2Outlined } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { accessKeys, hasAccess } from "../../utils/userAccess";
import PersonIcon from "@mui/icons-material/Person";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import CheckIcon from "@mui/icons-material/Check";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import LabelIcon from "@mui/icons-material/Label";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import HowToRegIcon from "@mui/icons-material/HowToReg";

export default function MarketNoteCard({ marketNote, menuItems }) {
  return (
    <>
      <Card sx={{ padding: "16px", marginBottom: "16px" }}>
        <div style={{ marginLeft: "0.5em" }}>
          <ActorAvatar
            name={marketNote.companyActorName}
            email={marketNote.companyActorEmail}
            profilePictureUrl={marketNote.companyActorImage}
            link={"/dashboard/company/" + marketNote.companyActorId}
          />
        </div>

        <Box sx={{ position: "absolute", top: "20px", right: "16px", zIndex: 1 }}>
          <DotMenu content={menuItems} horizontal />
        </Box>

        <Grid container spacing={2} style={{ marginTop: "2em", margin: "1em" }}>
          <Grid item size={{ md: 2, xs: 2 }}>
            <Tooltip title={Translate.get("ContactPerson")}>
              <HeadsetMicIcon />
            </Tooltip>
          </Grid>
          <Grid item size={{ md: 10, xs: 10 }}>
            <Typography>{marketNote.contactPersonActorName}</Typography>
          </Grid>

          <Grid item size={{ md: 2, xs: 2 }}>
            <Tooltip title={Translate.get("Note")}>
              <StickyNote2Icon />
            </Tooltip>
          </Grid>
          <Grid item size={{ md: 10, xs: 10 }}>
            <Tooltip title={marketNote.textNote}>
              <Typography
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  margin: 0,
                }}
              >
                {marketNote.textNote}
              </Typography>
            </Tooltip>
          </Grid>

          <Grid item size={{ md: 2, xs: 2 }}>
            <Tooltip title={Translate.get("NotificationDate")}>
              <DateRangeIcon />
            </Tooltip>
          </Grid>
          <Grid item size={{ md: 10, xs: 10 }}>
            <Typography>{marketNote.notificationDate ? formatDate(marketNote.notificationDate) : ""}</Typography>
          </Grid>

          <Grid item size={{ md: 2, xs: 2 }}>
            <Tooltip title={Translate.get("Ready")}>
              <CheckCircleIcon />
            </Tooltip>
          </Grid>
          <Grid item size={{ md: 10, xs: 10 }}>
            <Typography>
              {marketNote.isDone ? (
                <CheckIcon sx={{ color: "success.main" }} />
              ) : (
                <HourglassTopIcon sx={{ color: "text.disabled" }} />
              )}
            </Typography>
          </Grid>

          <Grid item size={{ md: 2, xs: 2 }}>
            <Tooltip title={Translate.get("Created")}>
              <DateRangeIcon />
            </Tooltip>
          </Grid>
          <Grid item size={{ md: 10, xs: 10 }}>
            <Typography>{formatDate(marketNote.regDate)}</Typography>
          </Grid>

          <Grid item size={{ md: 2, xs: 2 }}>
            <Tooltip title={Translate.get("Responsible")}>
              <HowToRegIcon />
            </Tooltip>
          </Grid>
          <Grid item size={{ md: 10, xs: 10 }}>
            <Typography>{marketNote.responsibleEPortUserName}</Typography>
          </Grid>

          <Grid item size={{ md: 2, xs: 2 }}>
            <Tooltip title={Translate.get("Labels")}>
              <LabelIcon />
            </Tooltip>
          </Grid>
          <Grid item size={{ md: 10, xs: 10 }}>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              {marketNote.marketNoteLabels?.map((label) => (
                <Chip key={label.marketNoteLabelId} label={label.labelText} size="small" style={{ margin: "0.2em" }} />
              ))}
            </Box>
          </Grid>
        </Grid>

        {/* <ActorAvatar
          name={actorName}
          email={actorEmail}
          profilePictureUrl={actorPictureUrl}
          link={showPermitDetailsButton ? null : "/dashboard/person/" + actorId}
        />
        <Box sx={{ position: "fixed", top: "18px", right: "16px" }}>
          <DotMenu content={extraActions} horizontal />
        </Box>
        <Grid container spacing={4} direction="column" sx={{ padding: "30px 18px 16px 18px" }}>
          <Grid container alignItems="center">
            <ConstructionIcon />
            <Box marginLeft="19px">{machineGroup}</Box>
          </Grid>
          {!showPermitDetailsButton && (
            <Grid container alignItems="center">
              <BuildIcon />
              <Box marginLeft="19px">{machineTypes}</Box>
            </Grid>
          )}

          <Grid container alignItems="center">
            <DateRangeIcon />
            <Box marginLeft="19px">{formatDateRange(validFrom, validTo)}</Box>
          </Grid>

          {!showPermitDetailsButton && (
            <Grid container alignItems="center">
              <AccountBoxIcon />
              <Box marginLeft="19px">
                <TableAvatar
                  hideImage
                  boldTitle={false}
                  title={responsibleActorName}
                  subtitle={[responsibleActorEmail ?? ""]}
                />
              </Box>
            </Grid>
          )}

          <Grid container alignItems="center">
            <Tooltip title={Translate.get("Review")}>
              <PreviewIcon />
            </Tooltip>
            <Box marginLeft="19px">
              {reviewer}{" "}
              {reviewIsDue ? (
                <Tooltip title={Translate.get("ReviewNeeded")}>
                  <PendingActionsIcon style={{ transform: "translateY(0.15em)" }} />
                </Tooltip>
              ) : (
                ""
              )}
              <br />
              {reviewDate != null ? formatDate(reviewDate) : ""}
            </Box>
          </Grid>

          <Grid container alignItems="center">
            <CheckCircleIcon />
            <Box marginLeft="19px" alignItems="center" display="flex">
              {renderPermitStatus(permitStatusToSortableValue(permit), permit)}
            </Box>
          </Grid>
          {(permit.blobFile === null ? !!permit.handleDownloadActorPermit : !!permit.downloadCustomPermit) && (
            <Grid container justifyContent="flex-end">
              <Button
                className="regularButtonWithIcon stdLightLoader"
                variant="outlined"
                sx={{ width: 80 }}
                loading={permit.actorPermitId === permit.loading}
                onClick={(event) => {
                  event.stopPropagation();
                  if (permit.blobFile === null) {
                    permit.handleDownloadActorPermit(permit.actorPermitId, permit.actorName ?? actorName);
                  } else {
                    permit.downloadCustomPermit(permit.blobFile.blobDocumentId);
                  }
                }}
              >
                <DownloadIcon />
              </Button>
            </Grid>
          )}
          {showPermitDetailsButton && (
            <Grid container alignItems="center">
              <Button
                onClick={() => setShowPermitDetails(true)}
                size="large"
                variant="contained"
                fullWidth={true}
                sx={{ marginTop: "6px" }}
                startIcon={<RemoveRedEye />}
              >
                {Translate.get("Show")}
              </Button>
            </Grid>
          )}
        </Grid> */}
      </Card>
    </>
  );
}
